"use strict";
exports.__esModule = true;
exports.WorkflowExecutionStatusEnum = void 0;
var WorkflowExecutionStatusEnum;
(function (WorkflowExecutionStatusEnum) {
    WorkflowExecutionStatusEnum["Started"] = "STARTED";
    WorkflowExecutionStatusEnum["Running"] = "RUNNING";
    WorkflowExecutionStatusEnum["Succeeded"] = "SUCCEEDED";
    WorkflowExecutionStatusEnum["Failed"] = "FAILED";
    WorkflowExecutionStatusEnum["Aborted"] = "ABORTED";
    WorkflowExecutionStatusEnum["Reversed"] = "REVERSED";
    WorkflowExecutionStatusEnum["PartiallyReversed"] = "PARTIALLY_REVERSED";
    WorkflowExecutionStatusEnum["Cancelled"] = "CANCELLED";
})(WorkflowExecutionStatusEnum = exports.WorkflowExecutionStatusEnum || (exports.WorkflowExecutionStatusEnum = {}));
